import { Outlet } from 'react-router-dom';

const WorksheetsOutlet = () => {
  return <Outlet />;
};

export default WorksheetsOutlet;
